module.exports = __webpack_public_path__ + "img/about-mat.85379442.jpg";